<template>
    <div
        v-if="parts.length > 0"
        class="bo-product-details"
    >
        <span
            v-for="part in parts"
            :key="part.key"
            class="detail-item"
        >
            <i
                v-if="part.key === 'packsize'"
                class="icon-packing"
            ></i>
            <i
                v-else-if="part.key === 'weight'"
                class="icon-weight"
            ></i>
            <svg
                v-else-if="part.key === 'dimension'"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <rect
                    x="2"
                    y="8"
                    width="20"
                    height="8"
                    rx="1"
                />
                <path d="M6 8v3M10 8v4M14 8v3M18 8v4" />
            </svg>
            <svg
                v-else-if="part.key === 'volume'"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <path d="M12 2l9 5v10l-9 5-9-5V7z" />
                <path d="M3 7l9 5 9-5M12 12v10" />
            </svg>
            <i
                v-else-if="part.key === 'shipping'"
                class="icon-localshipping"
            ></i>
            <span class="detail-text">{{ part.text }}</span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        // from productDetailParts (js/frontend/utils/product-details.js)
        parts: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
